export const bookingMawbPiecesMapping = [
    {
        name: 'Pieces',
        value: 'i_pieces',
    },
    {
        name: 'Length',
        value: 'f_length',
    },
    {
        name: 'Width',
        value: 'f_width',
    },
    {
        name: 'Height',
        value: 'f_height',
    },
    {
        name: 'Weight',
        value: 'f_weight',
    },
    {
        name: 'CW',
        value: 'f_chargable_weight',
    },
    {
        name: 'SHC',
        value: 's_shc',
    },
    {
        name: 'Remarks',
        value: 's_piece_remark',
    }
]